// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"2dd02241","219":"0fe7a31f","573":"099f7264","616":"cd75f2f9","888":"04145bf3"}[chunkId] + ".chunk.css";
};